<template>
  <div :class="$style.phone">
    <div :class="$style.day">{{phone.day}}</div>
    <div :class="$style.time">{{phone.time}}</div>
    <div :class="$style.body">
      <div :class="$style.push">
        <div :class="$style.top">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.99481 8.41786H10.9973C11.55 8.41786 12 7.96016 12 7.39751V1.02035C12 0.457698 11.55 0 10.9973 0H1.00236C0.449629 0 0 0.457698 0 1.02035V7.39751C0 7.96016 0.449629 8.41786 1.00236 8.41786H2.26998L1.68682 11.6775C1.68575 11.6833 1.68754 11.6884 1.68718 11.6939C1.68503 11.7132 1.68647 11.7318 1.68825 11.7511C1.68969 11.7679 1.6904 11.7839 1.6947 11.7999C1.69935 11.816 1.70687 11.8302 1.71439 11.8455C1.72298 11.863 1.73086 11.8797 1.74303 11.8947C1.74625 11.8991 1.74732 11.9042 1.7509 11.9085C1.7577 11.9162 1.76665 11.9191 1.77417 11.9257C1.79028 11.941 1.80711 11.9541 1.82679 11.9647C1.84147 11.9723 1.85615 11.9778 1.87154 11.9829C1.88228 11.9865 1.89123 11.9934 1.90269 11.9956C1.9188 11.9985 1.93491 12 1.95066 12C1.98288 12 2.01402 11.9938 2.04302 11.9829C2.05018 11.9803 2.05626 11.9749 2.06306 11.9712C2.0849 11.961 2.10638 11.9493 2.12464 11.9333C2.12607 11.9319 2.12786 11.9315 2.12893 11.9304L5.99481 8.41786ZM2.63835 5.02521C2.19624 5.02521 1.83646 4.65897 1.83646 4.20893C1.83646 3.75888 2.19624 3.39265 2.63835 3.39265C3.08046 3.39265 3.44023 3.75888 3.44023 4.20893C3.44023 4.65897 3.08046 5.02521 2.63835 5.02521ZM5.19794 4.20893C5.19794 3.75888 5.55771 3.39265 5.99982 3.39265C6.44193 3.39265 6.80171 3.75888 6.80171 4.20893C6.80171 4.65897 6.44193 5.02521 5.99982 5.02521C5.55771 5.02521 5.19794 4.65897 5.19794 4.20893ZM8.56299 4.20893C8.56299 3.75888 8.92097 3.39265 9.3613 3.39265C9.80341 3.39265 10.1632 3.75888 10.1632 4.20893C10.1632 4.65897 9.80341 5.02521 9.3613 5.02521C8.92097 5.02521 8.56299 4.65897 8.56299 4.20893Z" fill="#09E56E"/>
          </svg>
          <span>Сообщение</span>
        </div>
        <span :class="$style.code">
          {{code}}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import days from '@/utils/days'

export default {
  name: 'phone',
  props: {
    code: String,
  },
  data: () => ({
    phone: {
      day: days((new Date()).getDay()),
      time: '',
    },
  }),
  methods: {
    updateTime() {
      const date = new Date()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const day = date.getDay()

      this.phone.day = days(day)
      this.phone.time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`

      setTimeout(() => this.updateTime(), 1000)
    },
  },
  created() {
    this.updateTime()
  },
}
</script>
<style lang="scss" module>
.phone {
  width: 28.5rem;
  height: 59.4rem;
  border: 1.2rem solid #000;
  border-radius: 3rem;
  position: fixed;
  bottom: -20rem;
  left: 38rem;
  background:linear-gradient(180deg, #FF7878 0%, #F57676 20.83%, #A37CF7 63.54%, #F576E1 83.85%, #EB22CB 100%);
  box-shadow: 0 0 4rem rgba(0, 0, 0, 0.3);
  z-index: 9999999999;
  transform: translateZ(0);

  &:after, &:before {
    content: '';
    display: block;
    top: 1rem;
    position: absolute;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  &:after {
    width: 2.1rem;
    height: 1.2rem;
    background-image: url(./assets/phone2.svg);
    right: 2.5rem
  }

  &:before {
    width: 1.8rem;
    height: 1.3rem;
    background-image: url(./assets/phone1.svg);
    left: 2.5rem;
  }
}

.day {
  position: absolute;
  top: 4.4rem;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 1.6rem;
  color: #fff;
}

.time {
  position: absolute;
  font-weight: 300;
  font-size: 8.2rem;
  top: 7.5rem;
  color: #fff;
  left: 0;
  right: 0;
  text-align: center;
}

.body {
  position: absolute;
  top: 19rem;
  width: 100%;
  left: 0;
  padding: 0 1.3rem;
}

.push {
  background: #fff;
  box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 1rem;
  font-size: 1.8rem;
}

.top {
  font-size: 0.8rem;
  color: rgba(#000, 0.3);
  margin-bottom: 0.5rem;

  span {
    position: relative;
    top: -0.6rem;
  }
  svg {
    width: 1.2rem;
    height: auto;
    margin-right: 0.4rem;
  }
}

.code {
  letter-spacing: 0.4rem;
}
</style>
